export const preventNegativeKey = (event) => {
    if (event.key === "-" || event.key === "Minus") {
        event.preventDefault();
    }
};
